import { useRef, useState, useCallback } from "react";
import api from "@/lib/api";

// Debounced real-time duplicate check while typing telefono / email / codice fiscale.
export function useDupCheck(tipo, escludiId) {
  const [dup, setDup] = useState(null);
  const timer = useRef(null);
  const vals = useRef({});

  const check = useCallback((field, value) => {
    vals.current[field] = value;
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      const { telefono, email, codice_fiscale, societa_piva } = vals.current;
      if (!telefono && !email && !codice_fiscale && !societa_piva) { setDup(null); return; }
      try {
        const { data } = await api.get("/clienti/check-duplicate", { params: { tipo, telefono, email, codice_fiscale, societa_piva, escludi_id: escludiId || undefined } });
        setDup(data.duplicate ? data : null);
      } catch {
        /* silent — the create call will still guard against duplicates */
      }
    }, 500);
  }, [tipo, escludiId]);

  return { dup, setDup, check };
}
